// extracted by mini-css-extract-plugin
module.exports = {"projectContactLoading":"ProjectHeader_projectContactLoading__1nURX"};